import React, { useContext, useEffect, useRef, useState } from "react";
import styles from './ProductCard.module.css';
import { useNavigate } from "react-router-dom";
import buttonStyles from '../../buttons/Buttons.module.css';
import { QuoteBasketContext } from "../../providers/QuoteBasketProvider";
import { displayCommas, numberTo2sf } from "../../../functions/NumericalFunctions";
import { LoggedInContext } from "../../providers/LoggedInContext";

export default function ProductCardV3({basketItem,productArray,type}){

    const {basketArray,setBasketArray,handleUpdateBasket} = useContext(QuoteBasketContext);
    const {user} = useContext(LoggedInContext);

    const navigate = useNavigate();

    const [productDetails,setProductDetails] = useState(null);

    useEffect(() => {
        const index = productArray.findIndex((product) => product.id === basketItem.id);
        if(index > -1){
            setProductDetails(productArray[index]);
        }
    },[productArray]);

    // const [mouseOver,setMouseOver] = useState(false);
    // const [currentImg,setCurrentImg] = useState(0);
    // const [width,setWidth] = useState(0);
    const handleOpenProductSpecific = () => {
        window.scrollTo(0,0);
        navigate(`/hiq/catalogue/${productDetails.productGroupCode}/${basketItem.id}`);
    }

    const increaseQty = () => {
        setBasketArray((prev) => {
            let newArray = [...prev];
            const index = newArray.findIndex((item) => item.id === basketItem.id);
            if(index > -1){
                newArray[index] = {
                    ...newArray[index],
                    qty: Number(newArray[index].qty)+1
                }
            }
            handleUpdateBasket(user.id,newArray);
            return newArray;
        });
    }

    const decreaseQty = () => {
        setBasketArray((prev) => {
            let newArray = [...prev];
            const index = newArray.findIndex((item) => item.id === basketItem.id);
            if(index > -1){
                newArray[index] = {
                    ...newArray[index],
                    qty: newArray[index].qty > 1? newArray[index].qty-1 : newArray[index].qty
                }
            }
            handleUpdateBasket(user.id,newArray);
            return newArray;
        });
    }

    const removeItem = () => {
        setBasketArray((prev) => {
            let newArray = [...prev];
            newArray = newArray.filter((item) => item.id !== basketItem.id);
            handleUpdateBasket(user.id,newArray);
            return newArray;
        });
    }

    const select = (e) => {
        e.target.select();
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setBasketArray((prev) => {
            let newArray = [...prev];
            const index = newArray.findIndex((item) => item.id === basketItem.id);
            if(index > -1 && value > 0){
                newArray[index] = {
                    ...newArray[index],
                    qty: value
                }
            }
            return newArray;
        });
    }

    const handleBlur = (e) => {
        const value = e.target.value;
        setBasketArray((prev) => {
            let newArray = [...prev];
            const index = newArray.findIndex((item) => item.id === basketItem.id);
            if(index > -1 && value > 0){
                newArray[index] = {
                    ...newArray[index],
                    qty: Math.ceil(value)
                }
            }
            handleUpdateBasket(user.id,newArray);
            return newArray;
        });
    }

    const card = useRef();

    if(productDetails){
        if(type === "small"){
            return (
                <div className={`${styles.outerContainer} ${styles.small}`} key={"prod"+basketItem.id}>
                    <div ref={card} className={`${styles.cardContainer} ${styles.small} ${styles.landscape}`}>
                        <div className={styles.imgContainer} onClick={handleOpenProductSpecific}>
                            <div className={styles.imgDiv} style={{transition: '0.3s',backgroundImage: `url(${productDetails.imgUrl? productDetails.imgUrl.split(',')[0].replace('/s/','/shared/static/') : ''})`}}></div>
                        </div>
                        <div className={`${styles.cardDetails} ${styles.small}`}>
                            <div>
                                <p className={styles.code}>{productDetails.code}</p>
                                <p className={styles.name}>{productDetails.name}</p>
                            </div>
                            <p className={styles.cost}>{basketItem.qty} x £{(productDetails.stratelaSalesCost).toFixed(2)}</p>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={styles.outerContainer} key={"prod"+basketItem.id}>
                    <div ref={card} className={`${styles.cardContainer} ${styles.landscape}`}>
                        <div className={styles.imgContainer} onClick={handleOpenProductSpecific}>
                            <div className={styles.imgDiv} style={{transition: '0.3s',backgroundImage: `url(${productDetails.imgUrl? productDetails.imgUrl.split(',')[0].replace('/s/','/shared/static/') : ''})`}}></div>
                        </div>
                        <div className={styles.cardDetails}>
                            <div>
                                <p className={styles.code}>{productDetails.code}</p>
                                <h3>{productDetails.name}</h3>
                                <p className={styles.code}>{productDetails.description}</p>
                            </div>
                            <p className={styles.cost}>£{(productDetails.stratelaSalesCost).toFixed(2)}</p>
                        </div>
                        <div className={styles.quantityCon}>
                            <button className={`${buttonStyles.standardBorder} ${basketItem.qty === 1? buttonStyles.disabled : ''}`} onClick={decreaseQty}>-</button>
                            <input className={buttonStyles.inputStyleQty} onChange={handleChange} onBlur={handleBlur} onClick={select} value={basketItem.qty}/>
                            <button className={`${buttonStyles.standardBorder}`} onClick={increaseQty}>+</button>
                            <button className={`${buttonStyles.standard} ${styles.remove}`} onClick={removeItem}>Remove</button>
                        </div>
                        <p className={styles.subtotalCostProduct}>£{displayCommas(numberTo2sf(basketItem.qty*productDetails.stratelaSalesCost))}</p>
                    </div>
                </div>
            )
        }
    }
}